import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import Toggle from "react-toggle";
import { IoAdd, IoPencil, IoCopy, IoList, IoGrid } from "react-icons/io5";
import { Tooltip as ReactTooltip } from "react-tooltip";

import Searchbar from "./Searchbar";

import BreadCrumbs from "./BreadCrumbs";

const HeaderWrapper = ({
  breadcrumbs,
  icon,
  onClickAdd,
  onClickEdit,
  onClickAction,
  onFilter,
  isMobile,
  ticketView,
  fixedActions,
  onSearch,
  onDuplicate,
  onToggle,
  viewDisplay,
  loading,
  classNames,
  actionsWidth,
  scrollY,
  auth
}) => (
  <HeaderStyles className={`header-wrapper ${classNames}`}>
    {/* *** for most pages *** */}
    {!ticketView && (
      <>
        <BreadCrumbs breadcrumbs={breadcrumbs} icon={icon} />
        <Col
          md={6}
          xs={5}
          className={`flex -end ${
            fixedActions ? "header-actions-fixed" : ""
          } ${scrollY > 0 && "scrolled"}`}
          style={{ display: "flex", width: actionsWidth }}
        >
          {onToggle && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                minWidth: "15rem",
                marginTop: "2rem",
                marginRight: "1rem"
              }}
            >
              <label
                className="control-label"
                htmlFor="toggle-view"
                style={{ textTransform: "uppercase", paddingTop: "0.5rem" }}
              >
                {viewDisplay ? "Board View" : "List View"}
              </label>
              <div style={{ maxHeight: "2rem" }}>
                <Toggle
                  id="toggle-view"
                  checked={viewDisplay}
                  disabled={loading}
                  value={viewDisplay?.toString()}
                  icons={{
                    checked: <IoList />,
                    unchecked: <IoGrid />
                  }}
                  onChange={(e) => onToggle(e.target.checked)}
                />
              </div>
            </div>
          )}
          {onFilter && !isMobile && <Searchbar onFilter={onFilter} />}
          {onSearch && !isMobile && <Searchbar onSearch={onSearch} />}
          {onClickAction &&
            onClickAction.map(({ component: Component, ...a }, i) =>
              a.type === "select" ? (
                <div key={i} className="header-wrapper-select">
                  <Component />
                </div>
              ) : (
                <>
                  <button
                    key={i}
                    id={i}
                    className={`btn ${
                      a.className ? a.className : "btn-purple"
                    }`}
                    onClick={a.action}
                    disabled={a.disabled}
                    data-tooltip-variant={auth.isNightMode ? "dark" : "light"}
                  >
                    {a.icon && <React.Fragment>{a.icon}</React.Fragment>}
                    {a.text && a.text}
                  </button>
                  {a.tooltipContent ? (
                    <ReactTooltip
                      anchorId={i}
                      className={`custom-tooltip ${
                        auth.isNightMode ? "dark" : "light"
                      }`}
                      place="bottom"
                      type="light"
                      effect="solid"
                    >
                      <div>{a.tooltipContent}</div>
                    </ReactTooltip>
                  ) : null}
                </>
              )
            )}
          {onDuplicate && (
            <button className="btn btn-info pull-right" onClick={onDuplicate}>
              {isMobile ? <IoCopy /> : "Clone"}
            </button>
          )}
          {onClickAdd && (
            <button className="btn btn-success pull-right" onClick={onClickAdd}>
              {isMobile ? <IoAdd /> : "Add"}
            </button>
          )}
          {onClickEdit && (
            <button
              className="btn btn-warning pull-right"
              onClick={onClickEdit}
            >
              {isMobile ? <IoPencil /> : "Edit"}
            </button>
          )}
        </Col>
      </>
    )}

    {/* *** for mobile ticket view page *** */}
    {ticketView && (
      <>
        <Row>
          <BreadCrumbs breadcrumbs={breadcrumbs} icon={icon} xs={12} />
        </Row>
        <Row>
          <Col md={12} style={{ display: "flex" }}>
            {onFilter && !isMobile && <Searchbar onFilter={onFilter} />}
            {onClickAction &&
              onClickAction.map((a, i) => (
                <button
                  key={i}
                  className={`btn ${a.className ? a.className : "btn-purple"}`}
                  onClick={a.action}
                >
                  {a.icon && <React.Fragment>{a.icon}</React.Fragment>}
                  {a.text && a.text}
                </button>
              ))}
            {onDuplicate && (
              <button className="btn btn-info pull-right" onClick={onDuplicate}>
                {isMobile ? <IoCopy /> : "Clone"}
              </button>
            )}
            {onClickAdd && (
              <button
                className="btn btn-success pull-right"
                onClick={onClickAdd}
              >
                {isMobile ? <IoAdd /> : "Add"}
              </button>
            )}
            {onClickEdit && (
              <button
                className="btn btn-warning pull-right"
                onClick={onClickEdit}
              >
                {isMobile ? <IoPencil /> : "Edit"}
              </button>
            )}
          </Col>
        </Row>
      </>
    )}

    {isMobile && onFilter && (
      <Row>
        <Col xs={12}>
          <Searchbar onFilter={onFilter} />
        </Col>
      </Row>
    )}
  </HeaderStyles>
);

const HeaderStyles = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 0;
  h1 {
    font-size: 25px;
    font-weight: 800;
    letter-spacing: -1px;
  }
  .btn {
    margin-top: 10px;
    height: 40px;
    &.btn-success {
      margin-left: 1% !important;
    }
    &.btn-toggle {
      box-shadow: none !important;
      background: transparent !important;
      font-size: 20px;
      margin: 0;
      padding: 0 !important;
      &:focus,
      &:hover {
        background: transparent !important;
      }
    }
  }
  .favorite {
    margin-left: 10px;
    font-size: 16px;
  }
  p {
    margin-bottom: 0;
  }
`;

HeaderWrapper.propTypes = {
  breadcrumbs: PropTypes.array,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClickAdd: PropTypes.func,
  onClickEdit: PropTypes.func,
  onClickAction: PropTypes.oneOfType([PropTypes.func, PropTypes.array]),
  onFilter: PropTypes.func,
  ticketView: PropTypes.bool,
  isMobile: PropTypes.bool,
  onSearch: PropTypes.func,
  fixedActions: PropTypes.bool,
  onDuplicate: PropTypes.func,
  onToggle: PropTypes.func,
  viewDisplay: PropTypes.bool,
  loading: PropTypes.bool,
  classNames: PropTypes.string,
  actionsWidth: PropTypes.string,
  scrollY: PropTypes.number,
  auth: PropTypes.object
};

HeaderWrapper.defaultProps = {
  loading: false,
  classNames: "",
  actionsWidth: "100%",
  scrollY: 0,
  auth: {}
};

export default HeaderWrapper;
